import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/entrypoint.tsx';
import { isFedRamp } from '@atlassian/atl-context';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServiceDesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { browseConversationsRoute } from '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-routes/src/browseConversationsRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { VirtualAgentBrowseConversationsSkeleton } from '@atlassian/jira-skeletons/src/ui/virtual-agent/browse-conversations/VirtualAgentBrowseConversationsSkeleton.tsx';
import { browseConversationsEntryPoint } from '@atlassian/jira-spa-apps-virtual-agent-browse-conversations/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { FedRAMPFallbackRedirectToProjectSettings } from './common/index.tsx';

const browseConversationsPageEntryPoint = createPageEntryPoint({
	main: browseConversationsEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	redirect: userSegRedirectEntrypoint,
});

export const browseConversationsRouteEntry = createEntry(browseConversationsRoute, () => ({
	group: 'project-settings-servicedesk',
	layout: serviceProjectLayout,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServiceDesk,
		sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
	},

	entryPoint() {
		if (isFedRamp()) {
			return undefined;
		}
		return browseConversationsPageEntryPoint;
	},

	// this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
	component: FedRAMPFallbackRedirectToProjectSettings,

	skeleton: VirtualAgentBrowseConversationsSkeleton,
	resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

	meta: {
		reporting: {
			id: APP_NAMES.VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
			packageName: toPackageName(APP_NAMES.VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
			teamName: 'jsd-flux-capacitors',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/browseConversationsRouteEntry.tsx',
			whichExportToUse: 'browseConversationsRouteEntry',
		},

		enabled: true,
	},
}));
